import { SET_LOADING_PROGRESS } from '../actions/loadingProgess';

const initialState = {
  loadProgress: {},
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_LOADING_PROGRESS: {
      return {
        ...state,
        loadProgress: payload,
      };
    }
    default: {
      return state;
    }
  }
}
